import { CanActivateFn } from '@angular/router';
import { storeHomeRoute } from '@core/home/home-route-local-storage';

export const homeStoreCurrentRouteGuard: CanActivateFn = (route) => {
  if (route.url.length === 1) {
    storeHomeRoute(route.url[0].path);
  }
  return true;
};
